<script>
    import BaseTooltip from "@main/packages/BaseTooltip";

    export default {
        name: "ProductCardIcons",
        components: { BaseTooltip },
        props: {
            icons: [Object, Array],
            isSmall: Boolean,
            isOdd: Boolean,
        },
        computed: {
            sortedIcons() {
                return Object.entries(this.icons)
                    .sort(([, a], [, b]) => a.sort - b.sort)
                    .map((entry) => {
                        const [name, value] = entry;
                        return { name, ...value };
                    });
            },
        },
    };
</script>

<template>
    <div class="product-card-icons" :class="{ 'product-card-icons--sm': isSmall }">
        <div
            class="product-card-icons__image"
            v-for="(icon, index) in sortedIcons"
            :key="index"
        >
            <img :src="`/static/petoneer/catalog/${icon.name}.svg`" alt="" />
            <base-tooltip
                class="product-card-icons__tooltip"
                :position-x="isOdd ? 'left' : 'right'"
                :position-y="isSmall ? 'bottom' : 'top'"
            >
                {{ icon.value.replace(" (petoneer)", "") }}
            </base-tooltip>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-icons {
        position: relative;
        display: flex;
        @include bp($bp-desktop-sm) {
            cursor: pointer;
        }
    }
    .product-card-icons--sm {
        margin: 0 -1px;
        padding: 2px 8px 4px;
        background-color: #fff;
        .product-card-icons__image {
            width: 24px;
            height: 24px;
            margin: 0 1px;
        }
    }
    .product-card-icons__image {
        position: relative;
        z-index: 6;
        width: 24px;
        height: 24px;
        margin-right: 4px;
        @include bp($bp-tablet-sm) {
            margin-left: 4px;
            margin-right: 0;
        }
        &:hover {
            & > .product-card-icons__tooltip {
                display: block;
            }
        }
        @include bp($bp-desktop-sm) {
            width: 30px;
            height: 30px;
        }
    }
</style>
